<div class="block w-full rounded-2xl py-4 md:p-10 transition-all">
  <div
    class="text-center p-6 bg-white border-t-4 border-t-green-500 rounded-xl shadow-sm m-auto font-sans w-fit min-w-full md:min-w-2xl"
  >
    <div class="text-4xl mb-4">✅</div>
    <h2 class="text-slate-900">Submitted</h2>
    <p class="font-bold text-slate-500 mt-2 text-xl">
      <hsuc-safe-script
        [scriptCode]="renderStore.renderPayload().endStatePayload?.endMessage"
      ></hsuc-safe-script>
    </p>
  </div>
</div>
